/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerCustomerDemoEditComponent
 * Purpose		: This component retrieves data for the specified record id and allows to edit and save changes.
 * Dependency	: CustomerCustomerDemoService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit, HostBinding, EventEmitter, Input, Output,
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { CustomerCustomerDemoData, CustomerCustomerDemoService }  from './CustomerCustomerDemo.service';

import { CustomersData, CustomersService } from '../Customers/Customers.service';


@Component({
  template: require('./CustomerCustomerDemoEdit.component.html'),
  providers: [CustomerCustomerDemoService
	, CustomersService
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class CustomerCustomerDemoEditComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }
 
	objCustomerCustomerDemo: CustomerCustomerDemoData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	
	CustomersList: CustomersData[];

	constructor(private route: ActivatedRoute, 
		private router: Router,
		private toastr: ToastsManager,
		private CustomerCustomerDemoService: CustomerCustomerDemoService
			, private  CustomersService:  CustomersService

	) {
		// this.id = parseInt(params.get('id'));
		this.objCustomerCustomerDemo = new CustomerCustomerDemoData();
	}

	ngOnInit() {
		this.route.params
		// (+) converts string 'id' to a number
		// .switchMap((params: Params) => this.CustomerCustomerDemoService.getByID(+params['id']))
		.switchMap((params: Params) => this.CustomerCustomerDemoService.getByID(params['id']))
		.subscribe((item: CustomerCustomerDemoData) => this.objCustomerCustomerDemo = item);
		this.getLookups();
	}

	updateCustomerCustomerDemo() {
		this.CustomerCustomerDemoService.updateCustomerCustomerDemoData(this.objCustomerCustomerDemo)
			.subscribe(record => this.router.navigate(['/CustomerCustomerDemo']),
				error =>  this.errorMessage = 'There was an error while updating record. Error: ' + <any>error,
				() => { 
					this.toastr.success('CustomerCustomerDemo record updated successfully...', 'Edit CustomerCustomerDemo');
					console.log('CustomerCustomerDemo record updated successfully...'); 
				}
			);
	}
  
	deleteCustomerCustomerDemo(id: string) {
		if (window.confirm('Are you sure you want to delete this CustomerCustomerDemo?') == true) 
		{
			this.CustomerCustomerDemoService.deleteCustomerCustomerDemo(this.objCustomerCustomerDemo.CustomerID.toString())
			.subscribe(record => this.router.navigate(['/CustomerCustomerDemo']),
				error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { 
					this.toastr.success('CustomerCustomerDemo record deleted successfully...', 'Delete CustomerCustomerDemo');
					console.log('CustomerCustomerDemo record deleted successfully...'); 
				}
			);
		}
	}

	gotoCustomerCustomerDemo() {
		let Id = this.objCustomerCustomerDemo ? this.objCustomerCustomerDemo.CustomerID : null;
		this.router.navigate(['/CustomerCustomerDemo']);
	}

	// Get Lookup List for Customers
    getCustomers() {
		this.CustomersService.getAll().subscribe(records => this.CustomersList=records);
    }

	getLookups() {

        this.getCustomers();
	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/CustomerCustomerDemo/CustomerCustomerDemoEdit.component.ts